export { RangeSlider, renderRangeSlider, useRangeSlider } from './components/RangeSlider/index';
export type {
  RangeSliderOnChangeData,
  RangeSliderProps,
  RangeSliderSlots,
  RangeSliderState,
  RangeSliderThumbDataAttributes,
  RangeSliderValue,
} from './components/RangeSlider/index';
